// src/components/ProtectedAdminRoute.js
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../../utils/firebase";

const ProtectedAdminRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
  
    useEffect(() => {
      const checkAdmin = async () => {
        const user = auth.currentUser;
        if (!user) {
          setIsAdmin(false);
          setLoading(false);
          return;
        }
  
        const userDoc = await getDoc(doc(db, "Users", user.uid));
        const role = userDoc.exists() ? userDoc.data().role : null;
  
        setIsAdmin(role === "admin");
        setLoading(false);
      };
  
      checkAdmin();
    }, []);
  
    if (loading) return null; // Or return a loading spinner
    if (!isAdmin) return <Navigate to="/" />;
  
    return children;
  };
  
export default ProtectedAdminRoute;
